<template>
	<div class="pui-form">
		<emergencyprocess-modals :modelName="modelName"></emergencyprocess-modals>
		<pui-form-header v-if="modelLoaded" :showHeader="!isCreatingElement">
			<emergencyprocess-form-header :modelPk="modelPk"></emergencyprocess-form-header>
		</pui-form-header>
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-row class="pui-form-layout">
				<v-col cols="12">
					<v-row dense>
						<!-- DATESTART -->
						<v-col cols="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<pui-date-field
								:id="`datestart-emergencyprocess`"
								v-model="model.datestart"
								:label="$t('emergencyprocess.datestart')"
								disabled
								required
								toplabel
								time
							></pui-date-field>
						</v-col>
						<!-- DATEEND -->
						<v-col cols="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<pui-date-field
								:id="`dateend-emergencyprocess`"
								v-model="model.dateend"
								:label="$t('emergencyprocess.dateend')"
								disabled
								toplabel
								time
							></pui-date-field>
						</v-col>
					</v-row>
					<v-row dense>
						<!-- REMARKSSTART -->
						<v-col cols="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<pui-text-area
								:id="`remarksstart-emergencyprocess`"
								v-model="model.remarksstart"
								:label="$t('emergencyprocess.remarksstart')"
								disabled
								toplabel
								maxlength="1000"
							></pui-text-area>
						</v-col>
						<!-- REMARKSEND -->
						<v-col cols="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<pui-text-area
								:id="`remarksend-emergencyprocess`"
								v-model="model.remarksend"
								:label="$t('emergencyprocess.remarksend')"
								disabled
								toplabel
								maxlength="1000"
							></pui-text-area>
						</v-col>
					</v-row>
				</v-col>
			</v-row>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from '@Pui9Mixins/PuiFormMethodsMixin';

export default {
	name: 'emergencyprocess-form',
	mixins: [PuiFormMethodsMixin],
	components: {},
	data() {
		return {
			modelName: 'emergencyprocess'
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		statuscodeItemsToSelect() {
			return [{ statuscode: this.model.statuscode }];
		}
	},
	created() {}
};
</script>
